export const environment = {
  production: false,
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyD1AZyiVqy5_l84yCwHEdIkGGkyMAZZ6Bw',
    authDomain: 'project-octopus-19520.firebaseapp.com',
    projectId: 'project-octopus-19520',
    storageBucket: 'project-octopus-19520.firebasestorage.app',
    messagingSenderId: '1090100869337',
    appId: '1:1090100869337:web:1f2cf83e78949bacbbe6c8',
  },
  surveyJS: {
    licenseKey: 'ZWYxZDNhM2EtZDZkMS00MTRkLTg1NDktZWRjNGQ1ZjFmZWY3OzE9MjAyNS0xMS0yMywyPTIwMjUtMTEtMjMsND0yMDI1LTExLTIz',
  },
};

export const projectNumber = 1090100869337;
////////////////////////////////////////////////////////////////////////////////////////////
// Constants
////////////////////////////////////////////////////////////////////////////////////////////

const region = 'us-central1';
export const latestGitCommitHash = 'LATEST_GIT_COMMIT_HASH';
export const buildTimestampMs = 1771042187;

////////////////////////////////////////////////////////////////////////////////////////////
// Env Specific Constants
////////////////////////////////////////////////////////////////////////////////////////////

// URL where functions are deployed
// The placeholder constant below is replaced with the actual hostname in a script.

export const host = `${region}-${environment.firebase.projectId}.cloudfunctions.net`;
export const baseURL = `https://${host}`;

////////////////////////////////////////////////////////////////////////////////////////////
// Upstash
////////////////////////////////////////////////////////////////////////////////////////////

export const UPSTASH_REDIS_REST_URL = 'https://growing-rat-36855.upstash.io';
